import React, { useEffect, useState } from 'react';
import { Col, Row } from 'reactstrap';
import KpiClientAssistancesHistoryDashboard from './KpiClientAssistancesHistoryDashboard';
import Layout from '../../components/Layout/Layout';
import AssistancesFromClient from '../../components/Assistances/AssistancesFromClient';
import { useLocation } from 'react-router-dom';
import { KpiService } from '../../services/KpiService';
import Toast from '../../helpers/Toast';

interface KpiClientAssistancesHistoryContainerProps {
    isActiveYearWeekColumn?: boolean | null;
}

const KpiClientAssistancesHistoryContainer: React.FC<KpiClientAssistancesHistoryContainerProps> = ({ ...props }) => {
    const [kpiData, setKpiData] = useState<any | null>(null);
    const [clientErpId, setClientErpId] = useState<string | null>(null);
    const [clientName, setClientName] = useState<string | null>(null);
    const kpiService = new KpiService();

    const fetchKpiDashboardMetrics = async () => {
        const response = await kpiService.KpiClientAssistancesHistoryDashboard(clientErpId ?? '');

        if (response.success === false) {
            Toast.Show("error", response.message);
            return;
        }
        setKpiData(response.obj);
    };

    useEffect(() => {
        if (clientErpId) {
            fetchKpiDashboardMetrics();
        }
    }, [clientErpId]);

    //#region codigo relevante para mostrar assistencia cliente
    const location = useLocation();
    useEffect(() => {
        if (location.state) {
            const { clientErpId, clientName } = location.state;
            if (clientErpId && clientName) {
                setClientErpId(clientErpId);
                setClientName(clientName);
            }
        }
    }, [location.state]);
    //#endregion


    return (
        <>
            <Layout>
                <div>
                    <Row style={{ flexDirection: "column", alignItems: "center" }}>
                        <Col xs={10} sm={10} md={10} lg={10} xl={10} className="h-40">
                            <KpiClientAssistancesHistoryDashboard
                                data={kpiData}
                            />
                        </Col>

                        {clientErpId && clientName && (
                            <Col xs={10} sm={10} md={10} lg={10} xl={10} className="h-40 p-2 bg-white shadow-md rounded-2xl">
                                <AssistancesFromClient
                                    clientErpId={clientErpId}
                                    clientName={clientName}
                                    showCreateNewAssistanceButton={false}
                                    showKpiClientAssistancesHistoryDashboardButton={false}
                                />
                            </Col>
                        )}
                    </Row>
                </div>
            </Layout>
        </>
    );
};

export default KpiClientAssistancesHistoryContainer;